<template>
  <iframe
    :src="`${certUrl}${fileName}.pdf#toolbar=0`"
    frameborder="0"
  />
</template>

<script>
import { certUrl } from '@/config/config';
import useCommon from '@/libs/globalComposition';

export default {
  name: 'PdfViewer',
  setup () {
    const { currentRoute } = useCommon();
    const fileName = currentRoute.params.fileName;

    return { certUrl, fileName };
  }
};
</script>

<style lang="scss">
#app {
  > .container {
    margin-top: 0px;
    min-height: 100%;
  }
}
</style>
<style lang="scss" scoped>
@import '@/scss/common/common.scss';

iframe {
  height: 100vh;
  width: 100%;
}
</style>
